import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const CompareModule = React.lazy(() => import("./CompareModule"));
const CompareTestOptionPage = React.lazy(() => import("./page/CompareTestOptionPage/CompareTestOptionPage"));

export const CompareModuleRoutes: RouteObject = {
  path: ":clientId/compare/*",
  element: <ModuleRoute El={CompareModule} moduleName="compare" blockWhenChurned />,
  children: [
    {
      path: ":tab?",
      element: <PageRoute El={CompareTestOptionPage} />,
    },
  ],
};
